import React, { Component } from "react";
import { connect } from "react-redux";
import { Layout, Menu, Drawer } from "antd";
import { Link } from "react-router-dom";
import "./body.css";
import { navigationAction } from "./Navigation";
import {
  strings,
  menuClick,
  getCoordinatorId,
  openNotificationWithIcon,
  history
} from "../../helpers";
import {
  inboxUnreadMark,
  unreadRoomsAction
} from "../Dashboard/dashboardActions";

const { Sider } = Layout;
const { SubMenu } = Menu;

/**
 * @function selectCurrentPage
 * @return pageNumber
 * @desc This function handles showing active page, if dashboard is selected then pageNumber will be 1,
 * else 2
 */
const selectCurrentPage = activePage => {
  let pageNumber = "";
  switch (activePage) {
    case "demo":
      pageNumber = "7";
      break;
    case "clinics":
      pageNumber = "1";
      break;
    case "clinics-details":
      pageNumber = "1";
      break;
    case "doctors":
      pageNumber = "2";
      break;
    case "labs":
      pageNumber = "3";
      break;
    case "lab-details":
      pageNumber = "3";
      break;
    case "pharmacies":
      pageNumber = "4";
      break;
    case "pharmacy-details":
      pageNumber = "4";
      break;
    case "doctor-details":
      pageNumber = "2";
      break;
    case "websites-detail":
      pageNumber = "1";
      break;
    case "domains":
      pageNumber = "2";
      break;
    case "users":
      pageNumber = "5";
      break;
    case "users-details":
      pageNumber = "5";
      break;
    case "promo-code":
      pageNumber = "6";
    case "web-upgrade":
      pageNumber = "8";
      break;
    case "news-feed":
      pageNumber = "9";
      break;
    case "weekly-status":
      pageNumber = "10";
      break;
    case "analytics":
      pageNumber = "11";
      break;

    case `news`:
      pageNumber = "9";
      break;
    case `saved_articles`:
      pageNumber = "9_1";
      break;
    case `care-cities`:
      pageNumber = "14";
      break;
    case `ad-campaigns`:
      pageNumber = "15";
      break;
    case `campaign-leads`:
      pageNumber = "16";
      break;
    default:
      break;
  }
  return pageNumber;
};

class LeftNav extends Component {
  rootSubmenuKeys = ["news"];

  constructor(props) {
    super(props);
    this.state = {
      showChatMessage: false,
      openKeys: [],
      titleRouteMapping: {
        news: `/news-feed`
      }
    };
  }

  // when url gets changed, it recieves the currentPage propsven
  // according current page we set the selectedPage
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.currentPage !== prevState.selectedPage) {
      return { selectedPage: selectCurrentPage(nextProps.currentPage) };
    }

    return null;
  }

  componentDidMount() {
    const activeItem = this.props.currentPage;
    // if the current page props have any _ in it
    // we have to open the submenu also

    const selectedPage = selectCurrentPage(activeItem);
    this.setState({
      openKeys: [selectedPage],
      selectedPage
    });
  }

  /**
   * @function onNewChatMessageReceived
   * @desc function that handles chat messages
   */
  onNewChatMessageReceived = data => {
    // this.setState({ showChatMessage: true });
    const { markUnread, unreadRooms, addUnreadRoom } = this.props;

    if (unreadRooms && unreadRooms.indexOf(data.room_id) === -1) {
      unreadRooms.push(data.room_id);
      addUnreadRoom(unreadRooms);
    }
    markUnread(true);
    openNotificationWithIcon(
      "success",
      strings.newChatMessage,
      strings.chatMessageDescription
    );
  };

  /**
   * @function goToPage
   * @param page
   * @desc this function allows user to navigate to "page"
   */
  goToPage = e => {
    if (e.key === "4") {
      const { markUnread } = this.props;
      markUnread(false);
      this.setState({ showChatMessage: false });
    }
    menuClick(e, this.props.navigateTo);
  };

  handleSubMenuTitleClick = ({ key }) => {
    const { openKeys, titleRouteMapping } = this.state;
    if (!openKeys.includes(key)) {
      history.push(titleRouteMapping[key]);
    }
  };

  /**
   * @function onOpenChange
   * @desc handles open and close submenu
   */
  onOpenChange = openKeys => {
    const latestOpenKey = openKeys.find(
      key => this.state.openKeys.indexOf(key) === -1
    );

    if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
      this.setState({ openKeys });
    } else {
      this.setState({
        openKeys: latestOpenKey ? [latestOpenKey] : []
      });
    }
  };

  render() {
    const { currentPage, mark } = this.props;
    const selectedPage = selectCurrentPage(currentPage);
    const prodUrl = process.env.REACT_APP_PRODUCTION_URL;
    const environment = window.location.href;
    let showDemoTab = false;
    if (!environment.includes(prodUrl)) {
      showDemoTab = true;
    }
    const role = localStorage.getItem("account_type");

    return (
      <>
        <Drawer
          title={null}
          placement="left"
          visible={this.props.collapsed}
          onClose={this.props.handleNavbarCollapse}
        >
          <Sider trigger={null} collapsible>
            {/* subscribe to pusher for chat notifications */}

            <Menu
              theme="light"
              mode="inline"
              className="sidebar"
              selectedKeys={[selectedPage]}
              defaultOpenKeys={["news"]}
              onOpenChange={this.onOpenChange}
              openKeys={this.state.openKeys}
              // onClick={e => this.goToPage(e)}
            >
              <Menu.Item key="1">
                <Link to="/">Clinics</Link>
              </Menu.Item>
              <Menu.Item key="2">
                <Link to="/doctors">{strings.dashboard.doctor}</Link>
              </Menu.Item>
              <Menu.Item key="3">
                <Link to="/labs">{strings.dashboard.lab}</Link>
              </Menu.Item>
              <Menu.Item key="4">
                <Link to="/pharmacies">{strings.dashboard.pharmacy}</Link>
              </Menu.Item>
              {role === "billing_admin" && (
                <Menu.Item key="5">
                  <Link to="/users">{strings.dashboard.users}</Link>
                </Menu.Item>
              )}
              {role === "super_admin" && (
                <Menu.Item key="5">
                  <Link to="/users">{strings.dashboard.users}</Link>
                </Menu.Item>
              )}
              {role === "billing_admin" && (
                <Menu.Item key="6">
                  <Link to="/promo-code">{strings.dashboard.promoCode}</Link>
                </Menu.Item>
              )}
              {role === "super_admin" && (
                <Menu.Item key="6">
                  <Link to="/promo-code">{strings.dashboard.promoCode}</Link>
                </Menu.Item>
              )}
              {role === "super_admin" && (
                <Menu.Item key="7">
                  <Link to="/demo">Demo</Link>
                </Menu.Item>
              )}
              {role === "super_admin" && (
                <Menu.Item key="8">
                  <Link to="/web-upgrade">Web Upgrade</Link>
                </Menu.Item>
              )}
              <Menu.Item key="9">
                <Link to="/news-feed">News Feed</Link>
              </Menu.Item>

              <SubMenu
                onTitleClick={this.handleSubMenuTitleClick}
                key="news"
                title={
                  <React.Fragment>
                    <span>{"News"}</span>
                  </React.Fragment>
                }
              >
                <Menu.Item key="9">
                  <Link to="/news-feed">
                    <span>{"News feed"}</span>
                  </Link>
                </Menu.Item>

                <Menu.Item key="9_1">
                  <Link to={`/saved_articles`}>
                    <span>{"Interests"}</span>
                  </Link>
                </Menu.Item>
              </SubMenu>

              <Menu.Item key="10">
                <Link to="/weekly-status">Weekly news data</Link>
              </Menu.Item>
              <Menu.Item key="11">
                <Link to="/analytics">Analytics</Link>
              </Menu.Item>
            </Menu>
          </Sider>
        </Drawer>
        <Sider trigger={null} collapsible className="side-nav">
          {/* subscribe to pusher for chat notifications */}

          <Menu
            theme="light"
            mode="inline"
            className="sidebar"
            selectedKeys={[selectedPage]}
            defaultOpenKeys={["news"]}
            onOpenChange={this.onOpenChange}
            openKeys={this.state.openKeys}
            // onClick={e => this.goToPage(e)}
          >
            {role === "super_admin" && (
              <Menu.Item key="5">
                <Link to="/users">{strings.dashboard.users}</Link>
              </Menu.Item>
            )}
            {role === "billing_admin" && (
              <Menu.Item key="5">
                <Link to="/users">{strings.dashboard.users}</Link>
              </Menu.Item>
            )}
            <Menu.Item key="1">
              <Link to="/">Clinics</Link>
            </Menu.Item>
            <Menu.Item key="2">
              <Link to="/doctors">{strings.dashboard.doctor}</Link>
            </Menu.Item>
            <SubMenu
              onTitleClick={this.handleSubMenuTitleClick}
              key="news"
              title={
                <React.Fragment>
                  <span>{"News"}</span>
                </React.Fragment>
              }
            >
              <Menu.Item key="9">
                <Link to="/news-feed">
                  <span>{"News feed"}</span>
                </Link>
              </Menu.Item>
              <Menu.Item key="12">
                <Link to="/weekly-news">Weekly news</Link>
              </Menu.Item>
              <Menu.Item key="10">
                <Link to="/weekly-status">Weekly news data</Link>
              </Menu.Item>
              <Menu.Item key="11">
                <Link to="/analytics">Analytics</Link>
              </Menu.Item>

              <Menu.Item key="9_1">
                <Link to={`/saved_articles`}>
                  <span>{"Interests"}</span>
                </Link>
              </Menu.Item>
            </SubMenu>

            <SubMenu
              onTitleClick={this.handleSubMenuTitleClick}
              key="campaigns"
              title={
                <React.Fragment>
                  <span>Campaigns</span>
                </React.Fragment>
              }
            >
              <Menu.Item key="15">
                <Link to="/ad-campaigns">Ad campaigns</Link>
              </Menu.Item>
              <Menu.Item key="16">
                <Link to="/campaign-leads">Leads</Link>
              </Menu.Item>
            </SubMenu>

            <Menu.Item key="10">
              <Link to="/referrals">Referrals</Link>
            </Menu.Item>
            {role === "super_admin" && (
              <Menu.Item key="8">
                <Link to="/web-upgrade">Web Upgrade</Link>
              </Menu.Item>
            )}

            <SubMenu
              onTitleClick={this.handleSubMenuTitleClick}
              key="misc"
              title={
                <React.Fragment>
                  <span>{"Misc"}</span>
                </React.Fragment>
              }
            >
              <Menu.Item key="3">
                <Link to="/labs">{strings.dashboard.lab}</Link>
              </Menu.Item>

              <Menu.Item key="4">
                <Link to="/pharmacies">{strings.dashboard.pharmacy}</Link>
              </Menu.Item>
              {role === "super_admin" && (
                <Menu.Item key="7">
                  <Link to="/demo">Demo</Link>
                </Menu.Item>
              )}
              {role === "billing_admin" && (
                <Menu.Item key="6">
                  <Link to="/promo-code">{strings.dashboard.promoCode}</Link>
                </Menu.Item>
              )}
              {role === "super_admin" && (
                <Menu.Item key="6">
                  <Link to="/promo-code">{strings.dashboard.promoCode}</Link>
                </Menu.Item>
              )}
              <Menu.Item key="14">
                <Link to="/care-cities">{"Care Cities"}</Link>
              </Menu.Item>
            </SubMenu>
          </Menu>
        </Sider>
      </>
    );
  }
}
const mapStateToProps = state => ({
  mark: state.dashboard.mark,
  unreadRooms: state.dashboard.rooms
});

const mapDispatchToProps = dispatch => {
  return {
    navigateTo: (page, tab) => dispatch(navigationAction(page, tab)),
    markUnread: mark => dispatch(inboxUnreadMark(mark)),
    addUnreadRoom: rooms => dispatch(unreadRoomsAction(rooms))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LeftNav);
